import { Component, Input, OnInit } from '@angular/core';
// NGRX
import { select, Store } from '@ngrx/store';
// RxJS
import { Observable } from 'rxjs';

import { User } from '../../../../core/auth';
// AppState
import { AppState } from '../../../../core/reducers';
import { GConfig, selectGConfigById } from '../../../../core/rex';

@Component({
  selector: 'kt-intro-message',
  templateUrl: './intro-message.component.html',
  styleUrls: ['./intro-message.component.scss'],
})
export class IntroMessageComponent implements OnInit {
  @Input() user: Observable<User>;
  im: Observable<GConfig>;
  expanded = false;

  constructor(private store: Store<AppState>) {}

  ngOnInit() {
    this.im = this.store.pipe(select(selectGConfigById('authenticated__im')));
  }

  toggleExpanded() {
    this.expanded = !this.expanded;
  }
}
